import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterOutlet, RouterModule } from '@angular/router';
import { ApiService } from '../../services/api.service';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [CommonModule, RouterOutlet, RouterModule],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss'
})
export class DashboardComponent {
  userName: string = 'Admin User';
  masterMenuOpen: boolean = false;
  totalUsers: number = 0;

  constructor(
    private router: Router,
    private apiService: ApiService
  ) {
    this.loadUserInfo();
    this.loadDashboardStats();
  }

  loadDashboardStats() {
    this.apiService.listUsers().subscribe({
      next: (response) => {
        if (response && response.totalCount !== undefined) {
          this.totalUsers = response.totalCount;
        } else if (response && response.data) {
          this.totalUsers = response.data.length;
        }
      },
      error: (err) => {
        console.error('Failed to load dashboard stats', err);
      }
    });
  }

  toggleMasterMenu() {
    this.masterMenuOpen = !this.masterMenuOpen;
  }

  isDashboardHome(): boolean {
    return this.router.url === '/dashboard';
  }

  private loadUserInfo() {
    const userJson = localStorage.getItem('user');
    if (userJson) {
      try {
        const user = JSON.parse(userJson);
        this.userName = `${user.first_name || user.firstName || ''} ${user.last_name || user.lastName || ''}`.trim() || user.username || 'Admin User';
      } catch (e) {
        console.error('Failed to parse user info', e);
      }
    }
  }

  navigateToUsers() {
    this.router.navigate(['/dashboard/users']);
  }

  onLogout() {
    // In a real app, you'd pass the actual refresh token
    const refreshToken = localStorage.getItem('refreshToken') || '';
    
    this.apiService.logout({ refreshToken }).subscribe({
      next: () => {
        this.clearSession();
      },
      error: () => {
        // Even if API fails, clear local session for safety
        this.clearSession();
      }
    });
  }

  private clearSession() {
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('user');
    this.router.navigate(['/login']);
  }
}
